import { useState } from "react";
import { weekRank, hotTopics } from "@/mocks/trending";

export default function RankBoard() {
  const [mode, setMode] = useState<"week" | "month">("week");

  return (
    <section className="w-full bg-foreground-950 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div className="text-background-50">
            <h2 className="flex items-center gap-2 text-2xl md:text-3xl font-black">
              <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-accent-500 text-foreground-950">
                <i className="ri-bar-chart-2-fill"></i>
              </span>
              91cg 热议排行榜
            </h2>
            <p className="mt-2 text-sm text-background-200/70">按周期回看谁是真·围观看点，热度走势一眼看穿。</p>
          </div>
          <div className="inline-flex shrink-0 items-center rounded-full border border-background-200/30 p-1 bg-background-800/40">
            {(["week", "month"] as const).map((m) => (
              <button
                key={m}
                onClick={() => setMode(m)}
                className={`cursor-pointer whitespace-nowrap px-4 py-1.5 rounded-full text-sm font-semibold transition-colors ${
                  mode === m ? "bg-accent-500 text-foreground-950" : "text-background-100/80 hover:text-background-50"
                }`}
              >
                {m === "week" ? "本周榜" : "本月榜"}
              </button>
            ))}
          </div>
        </div>

        {/* 榜单列表 + 右侧话题 */}
        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* 排行 */}
          <div className="lg:col-span-8 flex flex-col gap-2.5">
            {weekRank.map((r, idx) => (
              <a
                key={r.id}
                href="#top"
                className="group flex items-center gap-4 rounded-xl px-3 py-3 cursor-pointer hover:bg-background-800/40 transition-colors"
              >
                <span className={`font-display text-3xl w-9 text-center shrink-0 ${
                  idx === 0 ? "text-accent-400" : idx === 1 ? "text-accent-300" : idx === 2 ? "text-accent-200" : "text-background-500"
                }`}>
                  {idx + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <p className="text-[15px] font-medium text-background-50 truncate group-hover:text-accent-300 transition-colors">
                      {r.name}
                    </p>
                    <span className="shrink-0 rounded bg-background-700/70 px-1.5 py-0.5 text-[11px] text-accent-300">{r.tag}</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full rounded-full bg-background-800 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-accent-600 to-accent-400 transition-all duration-700"
                      style={{ width: `${r.value}%` }}
                    ></div>
                  </div>
                </div>
                <span className="shrink-0 w-12 text-right font-display text-xl text-accent-400">{r.value}</span>
              </a>
            ))}
          </div>

          {/* 话题墙 */}
          <div className="lg:col-span-4">
            <div className="rounded-2xl border border-background-200/20 bg-background-800/30 p-5">
              <h3 className="flex items-center gap-2 text-base font-bold text-background-50">
                <span className="w-6 h-6 flex items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                  <i className="ri-hashtag"></i>
                </span>
                正在热议
              </h3>
              <div className="mt-4 flex flex-col gap-2">
                {hotTopics.map((t) => (
                  <a
                    key={t.id}
                    href="#top"
                    className="flex items-center gap-3 rounded-xl px-3 py-2.5 cursor-pointer hover:bg-background-700/40 transition-colors"
                  >
                    <div className="relative h-9 w-1 shrink-0 rounded-full overflow-hidden bg-background-700">
                      <div
                        className="absolute bottom-0 left-0 w-full rounded-full bg-accent-500"
                        style={{ height: `${t.hot}%` }}
                      ></div>
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium text-background-50 truncate">{t.name}</p>
                      <p className="text-xs text-background-300/70">{t.count}</p>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}